import Signal from "libs/signals";

const $technicalAssistance = Signal({
  technicalAssistance: null,
});

export default $technicalAssistance;
